function isElementInViewport (el) {
  if (typeof jQuery === "function" && el instanceof jQuery) {
    el = el[0];
  }
  let rect = el.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /* or $(window).height() */
    rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
  );
}

const trackBanner = function (urlRedirect, urlRedirectMobile, trackPixels = false){
  if (!urlRedirectMobile || !urlRedirect){
    return;
  }
  if ((drupalSettings.nodeType && drupalSettings.nodeType === "news") || trackPixels){
    if (drupalSettings.facebookApiConverter && drupalSettings.facebookApiConverter.facebookTrackingEnabled && drupalSettings.facebookApiConverter.facebookUrlIp && drupalSettings.facebookApiConverter.facebook_pixel_2){
      const idEvent = Date.now();
      const idEventSha = SHA256(""+idEvent);
      if (typeof fbq !== "undefined"){
        fbq('trackSingle', drupalSettings.facebookApiConverter.facebook_pixel_2, 'ClickBanner', {}, {"eventID": "ClickBanner."+idEvent});
        const fbp = (getCookie("_fbp") && getCookie("_fbp").split("=").length > 1) ? getCookie("_fbp").split("=")[1]:"";
        const fbc = (getCookie("_fbc") && getCookie("_fbc").split("=").length > 1) ? getCookie("_fbc").split("=")[1]:"";
        if (!getCookie("publicIp") || getCookie("publicIp").split("=").length <= 1){
          jQuery.get(drupalSettings.facebookApiConverter.facebookUrlIp, function(data){
            createCookieWithValue("publicIp", data, 60);
            sendFacebookApiTracking("ClickBanner",drupalSettings.facebookApiConverter.facebook_pixel_2, 2, data, idEventSha, fbc, fbp);
          });
        } else {
          sendFacebookApiTracking("ClickBanner",drupalSettings.facebookApiConverter.facebook_pixel_2, 2,  getCookie("publicIp").split("=")[1], idEventSha, fbc, fbp);
        }
        //fb api
      }
    }

    if (typeof gtag !== "undefined"){
      gtag('event', 'conversion', {'send_to': 'AW-676572607/tXpHCMSypvsCEL_bzsIC'});
    }
  }
  window.open(window.innerWidth < 768 ? urlRedirectMobile : urlRedirect,'_blank');
};
initializeUtilsFunctions();
publish(trackBanner, "trackBanner");

window.addEventListener("scroll",()=>{
  const banners = document.querySelectorAll(".banner-cac");
  let i = 0;
  banners.forEach((banner) => {
    if (banner && isElementInViewport(banner) && !document.querySelector(".track-banner-"+i)){
      if (banner.hasAttribute("data-script-url")){
        let nodeElem = document.createElement("script");
        nodeElem.setAttribute("type", "text/javascript");
        nodeElem.setAttribute("async", "async");
        nodeElem.setAttribute("defer", "defer");
        nodeElem.setAttribute("class", "track-banner-"+i);
        nodeElem.setAttribute("src", banner.getAttribute("data-script-url"));
        document.querySelector("body").appendChild(nodeElem);
      }
      
      if (banner.hasAttribute("data-no-script-url")){
        const noScriptElem = document.querySelector(".track-banner-no-script");
        noScriptElem.innerHTML = "<img alt='noscript-track-img' src='"+banner.getAttribute("data-no-script-url")+"'/>";
      }
    }
    i++;
  })
 
})